import { useContext, useEffect } from 'react'

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from 'context/GlobalContextProvider'
import loadCollections from 'actions/collections/load'
import loadAccount from 'actions/account/load'

import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import Link from 'components/Link'

import s from './CollectionsLayout.module.css'

function CollectionsLayout({ children, ...props }) {
  const dispatch = useContext(GlobalDispatchContext)
  const { collections, account } = useContext(GlobalStateContext)

  useEffect(() => {
    if (!account.loggedIn) dispatch(loadAccount())
  }, [])

  useEffect(() => {
    if (account.loggedIn && !collections.loaded)
      dispatch(loadCollections(account.authToken, account.user.name))
  }, [account])

  return (
    <Layout contentClassName={s.container} {...props}>
      {/* TODO: Add seo */}
      {/* <WordpressSEO title={``} desc="Select Model Management" /> */}
      <nav className={s.menu}>
        <Link
          href="/collections/create"
          type="Collections"
          className={s.menuLink}
        >
          Create
        </Link>
        <Link href="/collections" type="Collections" className={s.menuLink}>
          Collections
        </Link>
        <Link
          href="/collections/account"
          type="Collections"
          className={s.menuLink}
        >
          Account
        </Link>
      </nav>
      <div className={s.content}>{children}</div>
    </Layout>
  )
}

export default CollectionsLayout
